var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconTip = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_tip")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bswap",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IP-\\u8BE6\\u60C5",
    transform: "translate(-1090.000000, -969.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-15",
    transform: "translate(129.000000, 475.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3\\u5907\\u4EFD-4",
    transform: "translate(24.000000, 271.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_tip",
    transform: "translate(937.000000, 223.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#979797",
    strokeWidth: 0.666666667,
    fill: "#D8D8D8",
    opacity: 0,
    x: 0.333333333,
    y: 0.333333333,
    width: 15.3333333,
    height: 15.3333333
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#ABA5BD",
    strokeWidth: 1.04347826,
    cx: 8,
    cy: 8,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,10.0458412 C7.5004926,10.0458412 7.09551594,10.4506979 7.09551594,10.9503253 C7.09551594,11.4498327 7.5004926,11.8548093 8,11.8548093 C8.4995074,11.8548093 8.90448406,11.4498327 8.90448406,10.9503253 C8.90448406,10.4506967 8.4995074,10.0458412 8,10.0458412 Z M7.97398899,9.33872699 C8.40425413,9.33872699 8.75299498,8.98986619 8.75299498,8.559721 L8.75299498,4.92419666 C8.75299498,4.49393152 8.40425531,4.14519067 7.97398899,4.14519067 C7.54372386,4.14519067 7.19498301,4.49405147 7.19498301,4.92419666 L7.19498301,8.559721 C7.19498301,8.98998614 7.54372268,9.33872699 7.97398899,9.33872699 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#ABA5BD",
    transform: "translate(8.000000, 8.000000) scale(1, -1) translate(-8.000000, -8.000000) "
  }))))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTip, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_tip.c56a84e1.svg";
export { ForwardRef as ReactComponent };